import clsx from 'clsx';
import multiIcon from './images/multi.svg';
export type ChainIconListProps = {
  data: string[];
  max: number;
  size?: string;
  spacing?: string;
  borderSize?: string;
  showOverviewNumber?: boolean;
  className?: string;
};

export function ChainIconList({
  className,
  data,
  max,
  size = '40px',
  spacing = '8px',
  borderSize = '2px',
  showOverviewNumber = false,
}: ChainIconListProps) {
  return (
    <div className={clsx(className, 'flex-wrap inline-flex items-center')}>
      {data.slice(0, max).map((item, index) => (
        <img
          key={index}
          src={item}
          className="border-solid border-white bg-white flex justify-center items-center rounded-full"
          style={{
            width: size,
            height: size,
            zIndex: max - index,
            marginLeft: index > 0 ? spacing : '0',
            borderWidth: borderSize,
          }}
          alt="Icon"
        />
      ))}
      {data.length > max &&
        (showOverviewNumber ? (
          <span
            style={{
              width: size,
              height: size,
              marginLeft: spacing,
            }}
            className=" border border-solid border-bds-gray-ele-border text-bds-gray-t2 text-xs font-semibold flex justify-center items-center rounded-full"
          >
            +{data.length - max}
          </span>
        ) : (
          <img
            src={multiIcon}
            style={{
              width: size,
              height: size,
            }}
            alt="More"
          />
        ))}
    </div>
  );
}
